<app-admin-localization-grid></app-admin-localization-grid>